module.exports = __webpack_public_path__ + "d31f78e16b7948dee7260df0b26a85be.MP3";